import { createStore } from "vuex";
import { sharedModule } from "search-observe-app";
import packageJson from "../../package.json";

const store = createStore({
  modules: {
    shared: sharedModule,
    app: {
      namespaced: true,
      state: () => ({
        pkg: packageJson,
        siteUrl: "https://search-trials.abrinc.com",
        incidental: true,
        refTables: {
          ref_observer: [],
          ref_photo_type: [],
          ref_cover_type: [],
          ref_ground_cover: [],
          ref_decoys: [],
        },
        dataTables: {
          decoy_trial: [],
          survey_photo_decoy: [],
        },
        tablePositions: {
          decoy_trial: -1,
          survey_photo_decoy: -1,
        },
        views: {},
      }),
      getters: {},
      mutations: {},
    },
  },
});
export default store;
